import { Button, createStyles, makeStyles } from "@material-ui/core";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { IDialogChildComponent } from "../../../reducers/dialog";
import { OrderCounter } from "./OrderCounter";

interface IOpenCollectionDialogProps extends IDialogChildComponent {
    orderCount: number;
    collectionItem: any;
    isDelete?: boolean;
}

const useStyles = makeStyles((theme) => createStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        width: "42.5rem",
        alignItems: "center"
    },
    counter: {
        paddingBottom: "1rem"
    },
    title: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "center",
        "& p": {
            margin: 0
        }
    },
    infoText: {
        width: "75%"
    },
    bold: {
        fontWeight: 600
    }
}))

export function OpenCollectionDialog({
    orderCount,
    collectionItem,
    isDelete,
    onClose,

}: IOpenCollectionDialogProps) {
    const { t } = useTranslation();
    const { root, title, counter, infoText } = useStyles();
    return <div className={root}>
        <div className={counter}>
            <OrderCounter orderCount={orderCount} isDelete={Boolean(isDelete)} />
        </div>
        <div className={title}>
            <p>{t(`forms.orders.pickup.${isDelete ? "outstandingCollectionPoint" : "openOrders"}`)}<strong>{collectionItem.name}</strong></p>
        </div>
        <div className={infoText}>
            <p>
                {isDelete ? <Trans i18nKey='forms.orders.pickup.deleteInfo' components={{ bold: <strong /> }}>
                </Trans>
                    : t('forms.orders.pickup.openOrdersInfo')}
            </p>
        </div>
        {!isDelete && <Button variant="contained" color="default" size="large" onClick={onClose}>
            {t('misc.continue')}
        </Button>}
    </div>
}